import Layout from './components/Layout'
import Wrapper from './components/Wrapper'
import Footer from './components/Footer/Footer'
import './App.css';

function App() {
  return (
    <>
      <Layout>
        <Wrapper />
      </Layout>
      <Footer />
    </>
  );
}

export default App;
